export default "__VITE_ASSET__1ac5d008__"